/* eslint-disable no-func-assign */
import { FC } from "react";
import styles from "./OutfitsList.module.css";
import Card from "../Card/Card";
import useWindowSize from "../../hooks/useWindowSize";
import { cardWidth } from "../../utils/layoutUtils";

interface Props {
  outfits: Array<any>;
  onShowModal: () => void;
  emptyString: string;
}
const ListCards: FC<Props> = ({ outfits, onShowModal, emptyString }) => {
  const windowSize = useWindowSize();
  const width = cardWidth(windowSize.width);
  return (
    <div className={styles.listCards}>
      {outfits.length ? (
        outfits.map((outfit) => {
          return (
            <Card
              key={outfit.id}
              onShowModal={onShowModal}
              onClick={onShowModal}
              itemPhotoURL={outfit.previewUrl}
              brandName={""}
              itemShoppingUrl={""}
              width={width}
            />
          );
        })
      ) : (
        <div
          style={{
            width: "100%",
            height: "50vh",
            display: "flex",
            alignSelf: "center",
            justifySelf: "center",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {emptyString}
        </div>
      )}
    </div>
  );
};
export default ListCards;
